class pageInput {
  constructor() {
    this.pageNum = 1
    this.pageSize = 10
    this.total = 0
  }
}
export default pageInput
